import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DropdownButton, Dropdown, Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { getSurveyRequests, surveyRequest, selectSurveyRequest, selectRequestSuccess } from "./surveyRequestSlice";
import { selectAdminListData } from "../homepage-banner/adminListSlice";
import { selectSurveys, listSurveys } from "../surveylist/surveyListSlice";
import { selectAllocatedSurveys, listAllocatedSurveys } from "../allocatedsurveylist/allocatedSurveyListSlice";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

export const AllocatedSurveyBusinessUserData = () => {
  const dispatch = useDispatch();
  const [adminSelected, setAdminSelected] = useState("");
  const [adminNameSelected, setAdminNameSelected] = useState("");
  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const [selectedSurveyID, setSelectedSurveyID] = useState("");
  const [selectedSurveyTitle, setSelectedSurveyTitle] = useState("");
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [surveysToRequest, setSurveysToRequest] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const orgsurveys = useSelector(selectSurveys);
  const allocatedsurveys = useSelector(selectAllocatedSurveys);
  const surveyRequestRecords = useSelector(selectSurveyRequest);
  const adminlist = useSelector(selectAdminListData);
  const requestSuccess = useSelector(selectRequestSuccess);

  const [refreshKey, setRefreshKey] = useState(0); // Add a refresh key

  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
    if (isOpen) {
      setRefreshKey((prev) => prev + 1); // Force re-render when opening
    }
  };
  useEffect(() => {

      dispatch(listSurveys()); //surveys allocated to the Org
      dispatch(listAllocatedSurveys()); //surveys allocated to the user
      dispatch(getSurveyRequests()); //surveys which are in pending accepted and rejected stage [Filter all the results from surveys allocated to the org and display only them]
    },[]);

  useEffect(() => {
    if (orgsurveys.length > 0 && allocatedsurveys.length >= 0 && surveyRequestRecords.length >= 0) {
      setSurveysToRequest(
        orgsurveys.filter(
          (item) =>
            !allocatedsurveys.some((aitem) => aitem.SK === item.SK) &&
            !surveyRequestRecords.some(
              (sitem) =>
                sitem.survey_title === item.author_title &&
                (sitem.sr_status === "PENDING" || sitem.sr_status === "ACCEPTED")
            )
        )        
      );
    }
  }, [orgsurveys.length, allocatedsurveys.length, surveyRequestRecords.length]); 


  useEffect(() => {
    if (requestSuccess) {
      setSurveysToRequest((prev) =>
        prev.filter((item) => item.author_title !== selectedSurveyTitle)
      );
    }
  }, [requestSuccess, selectedSurveyTitle]);

  const handleShowModal = (survey) => {
    setSelectedSurvey(survey);
    setSelectedSurveyID(survey.PK);
    setSelectedSurveyTitle(survey.author_title);
    setShowModal(true);
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedSurvey(null);
  };

  const setSurveyRequestRecord = (e) => {
    e.preventDefault();
    
    if (!adminSelected) {
      setError(true);
      return;
    }
    
    setError(false);
    
    dispatch(surveyRequest(selectedSurveyID, adminSelected, selectedSurveyTitle, adminNameSelected));
    
    setShowModal(false);  
    
    if (requestSuccess) {
      setSurveysToRequest((prev) =>
        prev.filter((item) => item.author_title !== selectedSurveyTitle)
      );
    }
  };

  return (
    <div>
      <Dropdown show={dropdownOpen}
      onClick={() => setDropdownOpen(!dropdownOpen)} 
      onToggle={(isOpen) => setDropdownOpen(isOpen)} 
    >
          <Dropdown.Toggle id="dropdown-basic-button" size="lg">
            Request Surveys
          </Dropdown.Toggle>

          <Dropdown.Menu key={refreshKey}> 
            {surveysToRequest.length > 0 ? (
              surveysToRequest.map((Item) => (
                <Dropdown.Item key={Item.PK} onClick={() => handleShowModal(Item)}>
                  {Item.author_title}
                </Dropdown.Item>
              ))
            ) : (
              <Dropdown.Item disabled>No surveys to request</Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Request Surveys</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedSurvey ? (
            <p>Do you want to request the survey: {selectedSurvey.author_title}?</p>
          ) : (
            <p>No survey selected</p>
          )}
          <p>Please select an admin to send the request to:</p>
          <Form.Group>
            <Form.Label>Select an Admin</Form.Label>
            <Form.Control
              as="select"
              value={adminSelected || ""}
              onChange={(e) => {
                const selectedIndex = e.target.selectedIndex;
                const selectedText = e.target.options[selectedIndex]?.text || "";
                setAdminNameSelected(selectedText);
                setAdminSelected(e.target.value);
              }}
              isInvalid={error}
            >
              <option value="">-- Select --</option>
              {adminlist.map((adminRow) => {
                const emailAttr = adminRow.email;
                return (
                  <option key={adminRow.username} value={emailAttr}>
                    {adminRow.username}
                  </option>
                );
              })}
            </Form.Control>
            {error && <Form.Control.Feedback type="invalid">Selection is required.</Form.Control.Feedback>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
          <Button variant="primary" disabled={!adminSelected} onClick={setSurveyRequestRecord}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AllocatedSurveyBusinessUserData;
